module.exports = __webpack_public_path__ + "img/eb85c9c.jpg";